/**
 * Öffentlicher Site-Origin für Canonical-/OG-/Schema.org-URLs.
 * In Produktion über das Build-Arg REACT_APP_SITE_URL setzen (muss zum Backend-APP_SITE_URL passen),
 * sonst driften Frontend-Canonicals und Backend-Sitemap auf verschiedene Domains.
 */
// non-www ist der kanonische Host: alle historischen Rankings/Canonicals der
// übernommenen Seite laufen auf https://radsport-events.de (www leitet per 301 dorthin).
export const SITE_ORIGIN = (process.env.REACT_APP_SITE_URL ?? 'https://radsport-events.de').replace(/\/$/, '');
